module.exports = __webpack_public_path__ + "img/Ghana.e59b3c1e.gif";